import { render, staticRenderFns } from "./FuxianPersonList.vue?vue&type=template&id=b27a9398&scoped=true"
import script from "./FuxianPersonList.vue?vue&type=script&lang=js"
export * from "./FuxianPersonList.vue?vue&type=script&lang=js"
import style0 from "./FuxianPersonList.vue?vue&type=style&index=0&id=b27a9398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27a9398",
  null
  
)

export default component.exports